import { authenticationService } from '../services/authenticationService';

export function handleResponse(response) {
    return response.text().then(text => {        
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api

                let logoutRedirectUrl = "/";
                const currentUser = authenticationService.currentUserValue;
                if (currentUser && currentUser.logoutRedirectUrl) {
                    logoutRedirectUrl = "/";
                }

                const logoutPromise = authenticationService.logout();

                logoutPromise
                    .then(() => {
                        window.location = logoutRedirectUrl;
                    });
            }

            throw new Error(text);
        }

        const data = text && JSON.parse(text);

        return data;
    });
}